// extracted by css-extract-rspack-plugin
export default {"StandaloneFaq":"OutroSection-module__StandaloneFaq__hUqun"};